<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="支付状态">
<!--                  <el-input style="width: 177px;" v-model="queryForm.payStatus"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.payStatus"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option v-for="(item,index) in moneyPayStatusList" :key="index" :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="支付类型">
<!--                  <el-input style="width: 177px;" v-model="queryForm.payType"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.payType"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option v-for="(item,index) in currencyTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="订单类型">
<!--                  <el-input style="width: 177px;" v-model="queryForm.orderType"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.orderType"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option v-for="(item,index) in orderTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="商品名称">
                  <el-input style="width: 177px;" v-model="queryForm.productName"></el-input>
              </el-form-item>
              <el-form-item label="店铺">
<!--                  <el-input style="width: 177px;" v-model="queryForm.shopId"></el-input>-->
                  <GridSelectU
                      style="width: 177px"
                      title="选择店铺"
                      labelName="shopName"
                      labelValue="id"
                      :value="queryForm.shopId"
                      :limit="1"
                      size="small"
                      placeholder="请选择商品"
                      @getValue="getSeachValuebrandId"
                      :columns="SHOP_code"
                      :searchs="SHOP_search"
                      dataListUrl="/mall/shop/findList"
                      entityBeanName="mallShop"
                      queryEntityUrl="/mall/shop/get"
                  >
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="门店">
<!--                  <el-input style="width: 177px;" v-model="queryForm.storeId"></el-input>-->
                  <GridSelectU
                      style="width: 177px"
                      title="选择门店"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.storeId"
                      :limit="1"
                      size="small"
                      placeholder="请选择门店"
                      @getValue="getSearchValueStoreId"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input style="width: 177px;" v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppMoneyPayList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addMppMoneyPay"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editMppMoneyPay(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppMoneyPay(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
              :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppMoneyPayList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>

        <span title="导出数据" class="icon-box" @click="exportMppMoneyRecordOutList">
            <Icon color="#606266">
                <ArrowDownload24Regular />
            </Icon>
        </span>

      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppMoneyPayList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="payLogo"
            label="图片"
            width="180"
        >
            <template slot-scope="scope">
                <div v-if='scope.row.payLogo'>
                    <el-image @click='updateSrcList(scope.row.payLogo)' style="width: 60px; height: 60px"
                              :src="scope.row.payLogo" :preview-src-list="srcList"> </el-image>
                </div>
                <div v-else>--</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payTitle"
        label="说明"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.payTitle'>
                  {{scope.row.payTitle}}
              </div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payMoney"
        label="支付金额"
        width="180"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="userId"
            label="用户"
            width="240"
        >
            <template slot-scope='scope'>
                <div v-if="scope.row.user">
                    <div style="flex: 1;margin-left: 10px;">
                        <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                        <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                    </div>
                </div>
                <div v-else>--</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payStatus"
        label="支付状态"
        width="180"
      >
          <template slot-scope="scope">
              {{returnmoneyPayStatus(scope.row.payStatus)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payType"
        label="支付类型"
        width="180"
      >
          <template slot-scope="scope">
              {{returncurrencyType(scope.row.payType)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payNo"
        label="外部交易号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderType"
        label="订单类型"
        width="180"
      >
          <template slot-scope="scope">
              {{returnOrderType(scope.row)}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderId"
        label="订单ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="productName"
        label="商品名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="merchantName"
        label="商户名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="shopId"
        label="店铺ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="门店ID"
        width="180"
      > </el-table-column>
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppMoneyPay(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editMppMoneyPay(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteMppMoneyPay(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppMoneyPayStates[mppMoneyPayState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppMoneyPay"
          ref="mppMoneyPayForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="说明"
            prop="payTitle"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppMoneyPay.payTitle"
              :disabled="mppMoneyPayState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="支付金额"
            prop="payMoney"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppMoneyPay.payMoney"
              :disabled="mppMoneyPayState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="支付状态"
            prop="payStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="mppMoneyPay.payStatus"-->
<!--              :disabled="mppMoneyPayState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="mppMoneyPay.payStatus"
                  :disabled="mppMoneyPayState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option v-for="(item,index) in moneyPayStatusList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="支付类型"
            prop="payType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="mppMoneyPay.payType"-->
<!--              :disabled="mppMoneyPayState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="mppMoneyPay.payType"
                  :disabled="mppMoneyPayState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option v-for="(item,index) in currencyTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="外部交易号"
            prop="payNo"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppMoneyPay.payNo"
              :disabled="mppMoneyPayState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单类型"
            prop="orderType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="mppMoneyPay.orderType"-->
<!--              :disabled="mppMoneyPayState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="mppMoneyPay.orderType"
                  :disabled="mppMoneyPayState == 'check'"
                  placeholder="请选择"
                  size="small"
              >
<!--                  <el-option label="已发放" :value="1"></el-option>-->
<!--                  <el-option label="未发放" :value="0"></el-option>-->
                  <el-option v-for="(item,index) in orderTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="订单ID"
            prop="orderId"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppMoneyPay.orderId"
              :disabled="mppMoneyPayState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商品名称"
            prop="productName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppMoneyPay.productName"
              :disabled="mppMoneyPayState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商户名称"
            prop="merchantName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppMoneyPay.merchantName"
              :disabled="mppMoneyPayState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="店铺"
            prop="shopId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="mppMoneyPay.shopId"-->
<!--              :disabled="mppMoneyPayState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectLi
                  style="width: 177px"
                  title="选择店铺"
                  labelName="shopName"
                  :disabled="mppMoneyPayState == 'check'"
                  labelValue="id"
                  :value="mppMoneyPay.shopId"
                  :limit="1"
                  size="small"
                  placeholder="请选择商品"
                  @getValue="getValuebrandId"
                  :columns="SHOP_code"
                  :searchs="SHOP_search"
                  dataListUrl="/mall/shop/findList"
                  entityBeanName="mallShop"
                  queryEntityUrl="/mall/shop/get"
              >
              </GridSelectLi>
          </el-form-item>
            <el-form-item
                label="门店"
                prop="storeId"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              style="width: 177px;"-->
                <!--              v-model="mppMoneyPay.storeId"-->
                <!--              :disabled="mppMoneyPayState == 'check'"-->
                <!--            ></el-input>-->
                <GridSelectLi
                    style="width: 177px"
                    title="选择门店"
                    labelName="storeName"
                    labelValue="id"
                    :value="mppMoneyPay.storeId"
                    :disabled="mppMoneyPayState == 'check'"
                    :limit="1"
                    size="small"
                    placeholder="请选择门店"
                    @getValue="getValueStoreId"
                    :columns="STORE_code"
                    :searchs="STORE_search"
                    dataListUrl="/shop/store/findList"
                    entityBeanName="shopStore"
                    queryEntityUrl="/shop/store/get"
                >
                </GridSelectLi>
            </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="mppMoneyPay.userId"-->
<!--              :disabled="mppMoneyPayState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName"
                           labelValue="id" title="选择用户" :value="mppMoneyPay.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="mppMoneyPayState == 'check'"
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
            <el-form-item
                label="logo"
                prop="payLogo"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              v-model="mppMoneyPay.payLogo"-->
                <!--              :disabled="mppMoneyPayState == 'check'"-->
                <!--            ></el-input>-->
                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                           :disabled="mppMoneyPayState == 'check'" class="avatar-uploader" :show-file-list="false"
                           :http-request="uploadImage">
                    <img v-if="mppMoneyPay.payLogo" :src="mppMoneyPay.payLogo" class="avatar" size="small" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppMoneyPayState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { SHOP, SHOP_SEARCH, STORE, STORE_SEARCH, UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import GridSelectU from '@/components/gridselect/index.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        GridSelectLi,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppMoneyPayList();
                    this.getMppMoneyPayList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppMoneyPayList();
                    this.getMppMoneyPayList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     payTitle: '', //说明
                     payLogo: '', //logo
                     payMoney: '', //支付金额
                     payStatus: '', //支付状态
                     payType: '', //支付类型
                     payNo: '', //外部交易号
                     orderType: '', //订单类型
                     orderId: '', //订单ID
                     productName: '', //商品名称
                     merchantName: '', //商户名称:店铺或者门店的名称
                     shopId: '', //店铺ID
                     storeId: '', //门店ID
                     userId: '', //用户ID
                },
                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                srcList:[''],
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                USER_code: USER,
                USER_search: USER_SEARCH,
                SHOP_code: SHOP,
                SHOP_search: SHOP_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppMoneyPayState: 'add',
                mppMoneyPayStates: {
                    add: '新建账单',
                    check: '查看账单',
                    edit: '修改账单'
                },

                multipleSelection: [],
                mppMoneyPayList: [],
                mppMoneyPay: {
                    id: '', //ID
                    payTitle: '', //说明
                    payLogo: '', //logo
                    payMoney: '', //支付金额
                    payStatus: '', //支付状态
                    payType: '', //支付类型
                    payNo: '', //外部交易号
                    orderType: '', //订单类型
                    orderId: '', //订单ID
                    productName: '', //商品名称
                    merchantName: '', //商户名称:店铺或者门店的名称
                    shopId: '', //店铺ID
                    storeId: '', //门店ID
                    userId: '', //用户ID
                },
                btnLoading: false,

                rules: {
                    payTitle: [{ required: true, message: '说明不能为空', trigger: 'blur' }],
                    payLogo: [{ required: true, message: 'logo不能为空', trigger: 'blur' }],
                    payMoney: [{ required: true, message: '支付金额不能为空', trigger: 'blur' }],
                    payStatus: [{ required: true, message: '支付状态不能为空', trigger: 'blur' }],
                    payType: [{ required: true, message: '支付类型不能为空', trigger: 'blur' }],
                    payNo: [{ required: true, message: '外部交易号不能为空', trigger: 'blur' }],
                    orderType: [{ required: true, message: '订单类型不能为空', trigger: 'blur' }],
                    orderId: [{ required: true, message: '订单ID不能为空', trigger: 'blur' }],
                    productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                    merchantName: [{ required: true, message: '商户名称:店铺或者门店的名称不能为空', trigger: 'blur' }],
                    shopId: [{ required: true, message: '店铺ID不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                },

                moneyPayStatusList: [],
                orderTypeList: [],
                currencyTypeList: [],
                storeOrderTypeList: [],
            };
        },
        created() {
            this.getMppMoneyPayList();
            this.getEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            beforeImageUpload(file){
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 50MB!');
                }
                return isLt2M;
            },
            // 大图预览
            updateSrcList(src) {
                this.srcList[0] = src
            },
            getValueUser(value){
                this.mppMoneyPay.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            getValueStoreId(value){
                this.mppMoneyPay.storeId = value
            },
            getSearchValueStoreId(value){
                this.queryForm.storeId = value
            },
            getValuebrandId(value){
                this.mppMoneyPay.shopId = value
            },
            getSeachValuebrandId(value){
                this.queryForm.shopId = value
            },
            // 获取枚举
            getEnum(){
                get("/mpp/utils/getEnum",{ enumType:"money_pay_status" }).then((res)=>{
                    if(res.success){
                        this.moneyPayStatusList = res.enumList
                    }
                })
                get("/mpp/utils/getEnum",{enumType: "order_type"}).then((res)=>{
                    if(res.success){
                        this.orderTypeList = res.enumList
                    }
                })
                get("/shop/utils/getEnum",{enumType: "store_order_type"}).then((res)=>{
                    if(res.success){
                        this.storeOrderTypeList = res.enumList
                    }
                })
                get("/mpp/utils/getEnum",{enumType: "order_pay_type"}).then((res)=>{
                    if(res.success){
                        for (let enumListElement of res.enumList) {
                            if(enumListElement.key == 1){
                                enumListElement.value = "抵扣券"
                            }
                        }
                        this.currencyTypeList = res.enumList
                    }
                })
            },
            returnmoneyPayStatus(key){
                for (var i = 0; i < this.moneyPayStatusList.length; i++) {
                    if(this.moneyPayStatusList[i].key == key){
                        return this.moneyPayStatusList[i].value
                    }
                }
            },
            returnOrderType(item){
                let key = item.orderType
                if(item.storeId){
                    for (var i = 0; i < this.storeOrderTypeList.length; i++) {
                        if(this.storeOrderTypeList[i].key == key){
                            return this.storeOrderTypeList[i].value
                        }
                    }
                }else if(item.shopId){
                    for (var i = 0; i < this.orderTypeList.length; i++) {
                        if(this.orderTypeList[i].key == key){
                            return this.orderTypeList[i].value
                        }
                    }
                }
            },
            returncurrencyType(key){
                for (var i = 0; i < this.currencyTypeList.length; i++) {
                    if(this.currencyTypeList[i].key == key){
                        return this.currencyTypeList[i].value
                    }
                }
            },
            //上传缩略图
            uploadImage(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.mppMoneyPay.payLogo = res.url;
                    }
                });
            },
            resetMppMoneyPayList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppMoneyPayList = [];
            },
            resetDialog() {
                this.mppMoneyPayState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      payTitle: '', //说明
                      payLogo: '', //logo
                      payMoney: '', //支付金额
                      payStatus: '', //支付状态
                      payType: '', //支付类型
                      payNo: '', //外部交易号
                      orderType: '', //订单类型
                      orderId: '', //订单ID
                      productName: '', //商品名称
                      merchantName: '', //商户名称:店铺或者门店的名称
                      shopId: '', //店铺ID
                      storeId: '', //门店ID
                      userId: '', //用户ID
                };
                this.getMppMoneyPayList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppMoneyPay = {
                      id: '', //ID
                      payTitle: '', //说明
                      payLogo: '', //logo
                      payMoney: '', //支付金额
                      payStatus: '', //支付状态
                      payType: '', //支付类型
                      payNo: '', //外部交易号
                      orderType: '', //订单类型
                      orderId: '', //订单ID
                      productName: '', //商品名称
                      merchantName: '', //商户名称:店铺或者门店的名称
                      shopId: '', //店铺ID
                      storeId: '', //门店ID
                      userId: '', //用户ID
                };
            },
            submitForm() {
                if (this.mppMoneyPayState == 'add') {
                    this.$refs.mppMoneyPayForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/moneypay/add`,{ ...this.mppMoneyPay }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppMoneyPayList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppMoneyPayState == 'edit') {
                    this.$refs.mppMoneyPayForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/moneypay/edit`,{ ...this.mppMoneyPay }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppMoneyPayList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppMoneyPay() {
                this.showDialog = true;
                this.mppMoneyPayState = 'add';
            },
            checkMppMoneyPay(mppMoneyPayId) {
                console.log(mppMoneyPayId);
                this.currentMppMoneyPayId = mppMoneyPayId;

                this.getMppMoneyPayById();
                this.showDialog = true;
                this.mppMoneyPayState = 'check';
            },
            editMppMoneyPay(mppMoneyPayId) {
                console.log('mppMoneyPay', mppMoneyPayId);
                if (mppMoneyPayId) {
                    this.currentMppMoneyPayId = mppMoneyPayId;
                    this.getMppMoneyPayById();
                } else {
                    this.mppMoneyPay = { ...this.mppMoneyPay, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppMoneyPayState = 'edit';
            },
            deleteMppMoneyPay(mppMoneyPayId) {
                let ids = '';
                if (mppMoneyPayId) {
                    ids = mppMoneyPayId;
                } else {
                    ids = this.multipleSelection.map((mppMoneyPay) => mppMoneyPay.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/moneypay/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppMoneyPayList();
                                this.getMppMoneyPayList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppMoneyPayList() {
                this.resetMppMoneyPayList();
                this.getMppMoneyPayList();
            },
            getMppMoneyPayList(query = {}) {
                this.loading = true;
                get(`/mpp/moneypay/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppMoneyPayList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppMoneyPayById() {
                get(`/mpp/moneypay/get`,{ id: this.currentMppMoneyPayId }).then((res) =>{
                    if(res.success){
                      this.mppMoneyPay = { ...this.mppMoneyPay, ...res.mppMoneyPay };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppMoneyPayList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/moneypay/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                // 设置按钮加载状态
                this.btnLoading = true;
                // 调用导入模板接口，传入API路径和按钮加载状态
                importTemplate(`/mpp/moneypay/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/moneypay/importData`,formData);
              this.refreshMppMoneyPayList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppMoneyPayList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppMoneyPayList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button{
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}

::v-deep .el-upload--text {
    width: 177px;
    height: 177px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 180px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>